import { render, staticRenderFns } from "./GoalCircleWidget.vue?vue&type=template&id=f8d9e80e&"
import script from "./GoalCircleWidget.vue?vue&type=script&lang=js&"
export * from "./GoalCircleWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports